import axios from "axios";

function getMessages({ threadId }) {
  //console.log(`api/messenger/threads/${threadId}/messages`);
  return axios.get(`api/messenger/threads/${threadId}/messages`);
}

function postMessages({ threadId }, value) {
  return axios.post(`api/messenger/threads/${threadId}/messages`, value);
}

function postImage({ threadId }, image) {
  return axios.post(`api/messenger/threads/${threadId}/images`, image);
}

function postDocument({ threadId }, document) {
  return axios.post(`api/messenger/threads/${threadId}/documents`, document);
}

function postAudio({ threadId }, audio) {
  return axios.post(`api/messenger/threads/${threadId}/audio`, audio);
}

function getPageMessages({ threadId, pageId }) {
  return axios.get(`api/messenger/threads/${threadId}/messages/page/${pageId}`);
}

function getMarkRead({ threadId }) {
  return axios.get(`api/messenger/threads/${threadId}/mark-read`);
}

function getMessengerThread({ userId }) {
  return axios.get(`api/v2/users/${userId}/messenger-thread`);
}

function postActivity({}, data) {
  return axios.post(`api/messages/activity`, data);
}

function postActivityStudent({ id }, data) {
  return axios.post(`api/messages/${id}/activity`, data);
}

function getActivityFromChat({ id }) {
  return axios.get(`api/messages/${id}/activity`);
}

function postActivityFromConversation({ conversationId }, data) {
  return axios.post(`api/conversations/${conversationId}/activity`, data);
}

export const messengerService = {
  getMessages,
  postMessages,
  getPageMessages,
  getMarkRead,
  postDocument,
  postImage,
  postAudio,
  getMessengerThread,
  postActivity,
  getActivityFromChat,
  postActivityStudent,
  postActivityFromConversation,
};
